import { SerializedBaseNode } from '@/features/screenplay/components/editor/nodes/BaseNode'
import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { SerializedContent } from '@/features/screenplay/components/editor/utils/JsonUtils'

export type SceneMetadata = SerializedBaseNode

/**
 * Extracts scene nodes from the serialized screenplay content.
 * This effectively parses the JSON structure to find all nodes of type 'scene'.
 */
export const extractScenesFromContent = (content: SerializedContent[]): SceneMetadata[] => {
    if (!content || !Array.isArray(content)) return []

    // The content structure from DB is SerializedContent[] which matches what Lexical exports.
    // Lexical's root has children.
    // Wait, SerializedContent[] usually represents the children of the root? 
    // Let's check JsonUtils again.
    // convertLexicalToDBJson returns `editorState.root.children.map(...)` -> SerializedContent[]
    // So `content` IS the array of nodes.

    return content.filter(node => node.type === NodeType.Scene) as unknown as SceneMetadata[]
}
